import { Link as RouterLink } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';
import Link from '@material-ui/core/Link';
import { Container } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

const Footer = () => {    
  // CUSTOM STYLES FOR PAGE
  const useStyles = makeStyles((theme) => ({
    paper: {
      background: 'transparent',
    },
    list: {
      lineHeight: '1.5',
      margin: 0,
      color: '#8c8c8c',
      '& li': {
        padding: '0 0 20px',
      },
    },
    innerList: {
      padding: '10px 24px',
      '& li': {
        fontSize: 'small',
      },
      '& li:last-child': {
        padding: 0,
      }
    },
    bodyPaper: {
      color: '#000',
      background: 'transparent',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
    },
    footer: {
      backgroundColor: '#232323'
    },
  }));
  
  const classes = useStyles();
  return (
  <div className={classes.footer} style={{ color: '#fff' }}>
      <Container>
        <Grid container spacing={3} style={{ padding: '30px 50px 0' }}>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom style={{ fontWeight: 'bold', color: '#9334ff' }}>
              VP Bunny NFT
            </Typography>
            <Typography paragraph variant="caption" style={{ color: '#9b9b9b' }}>
              VP Bunny NFTs offer all early fans of LasVegasVP a chance to collect unique VP Bunny art and gain access to special aspects of LasVegasVP stream and VP himself. A MUST have for fans of VP and NFT collectors alike.
            </Typography>
          </Grid>
          <Grid item xs={12} md={3}>
            <Typography variant="h6" gutterBottom style={{ fontWeight: 'bold', color: '#9334ff' }}>
              Social
            </Typography>
            <Typography paragraph variant="caption" style={{ color: '#9b9b9b' }}>
              <a href="https://discord.gg/lasvegasvp" style={{ color: '#9b9b9b' }} target="_blank" rel="noreferrer">Discord</a>
            </Typography>
            <Typography paragraph variant="caption" style={{ color: '#9b9b9b' }}>
              <a href="https://twitter.com/lasvegas_vp" style={{ color: '#9b9b9b' }} target="_blank" rel="noreferrer">Twitter</a>
            </Typography>
            <Typography paragraph variant="caption" style={{ color: '#9b9b9b' }}>
            <a href="https://www.tiktok.com/@lasvegasvp" style={{ color: '#9b9b9b' }} target="_blank" rel="noreferrer">Tiktok</a>
            </Typography>
          </Grid>
          <Grid item xs={12} md={3}>
            <Typography variant="h6" gutterBottom style={{ fontWeight: 'bold', color: '#9334ff' }}>
              Information
            </Typography>
            <Typography paragraph variant="caption" style={{ color: '#9b9b9b' }}>
              <Link component={RouterLink} to="/terms" style={{ color: '#9b9b9b' }}>Terms and Conditions</Link>
            </Typography>
            <Typography paragraph variant="caption" style={{ color: '#9b9b9b' }}>
              <Link component={RouterLink} to="/privacy" style={{ color: '#9b9b9b' }}>Privacy Policy</Link>
            </Typography>
            <Typography paragraph variant="caption" style={{ color: '#9b9b9b' }}>
              <Link component={RouterLink} to="/help" style={{ color: '#9b9b9b' }}>FAQs</Link>
            </Typography>
          </Grid>
          
          <Grid item xs={12} style={{ textAlign: 'center', borderTop: '1px solid #5c5c5c', padding: '20px 0', marginTop: 30 }}>
            <Typography variant="caption" style={{ color: '#9b9b9b' }}>
              Copyright &copy; 2022 <Link component={RouterLink} to="/" style={{ color: '#9334ff' }}>LasVegasVP</Link> All rights reserved.
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default Footer;